import React from "react";
import "../Styles/Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <main>
        <svg
          className="circle-loader"
          viewBox="0 0 128 128"
          width="128px"
          height="128px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="circle-loader__ring"
            cx="64"
            cy="64"
            r="51.2"
            fill="none"
            strokeWidth="12.8"
            strokeLinecap="round"
            stroke="#CBCDFB"
          />
          <circle
            className="circle-loader__worm"
            cx="64"
            cy="64"
            r="51.2"
            fill="none"
            strokeWidth="12.8"
            strokeLinecap="round"
            stroke="#3A36DB"
            strokeDasharray="281.49"
            strokeDashoffset="281.49"
          />
        </svg>
      </main>
    </div>
  );
};

export default Loader;